import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet"
import React, { useState } from "react"
import { useInfiniteQuery } from "@tanstack/react-query"
import { client } from "@/hooks/useClient"
import { endpoints } from "@/config/endpoints.config"
import { Scenario } from "@/gen"
import dayjs from "dayjs"
import { PaginatedResponse } from "@/types"
import { ExecutionNodesSheet } from "./ExecutionNodesSheet"
import { cn } from "@/lib/utils"
interface ExecutionsSheetProps {
  children: React.ReactNode
  scenario: Scenario
}

export function ExecutionsSheet(props: ExecutionsSheetProps) {
  const [open, setOpen] = useState(false)

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>{props.children}</SheetTrigger>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>Analítico</SheetTitle>
          <SheetDescription></SheetDescription>
        </SheetHeader>
        {open && <ExecutionsSheetContent {...props} />}
      </SheetContent>
    </Sheet>
  )
}

const limit = 20

function ExecutionsSheetContent(props: ExecutionsSheetProps) {
  const queryResult = useInfiniteQuery({
    queryKey: ["scenarios-analytic", props.scenario.id],
    queryFn: async ({ pageParam = 0 }) => {
      const offset = pageParam

      const response = await client.get<PaginatedResponse<any>>(`${endpoints.SCENARIOS}/${props.scenario.id}/executions`, {
        params: {
          limit,
          offset,
        },
      })

      return {
        data: response.data.data,
        nextPage: response.data.data.length < limit ? null : offset + limit, // Atualiza o offset para a próxima busca
        total: response.data.data.length,
      }
    },
    getNextPageParam: (lastPage: any) => lastPage?.nextPage,
    initialPageParam: 0,
  })

  const data = queryResult.data?.pages?.flatMap?.((page) => page.data) || []

  return (
    <div className="px-4">
      {data.map((execution) => (
        <ExecutionNodesSheet key={execution.id} execution={execution} scenario={props.scenario}>
          <button
            className={cn(
              "bg-ground rounded-2xl p-4 flex flex-col gap-1 text-xs mb-1 !text-left !w-full hover:bg-ground-active *:even:bg-ground-active *:flex *:justify-between *:py-0.5 *:px-2 *:rounded-lg ",
              execution.status === "done" && "bg-emerald-200 text-emerald-900 hover:bg-emerald-300 *:even:bg-emerald-500/20 ",
              execution.status === "failed" && "bg-red-200 text-red-900 hover:bg-red-300 *:even:bg-red-500/20",
            )}
          >
            <span className="font-bold text-sm">
              #{execution.id}
            </span>
            <span>
              <b>Status:</b> {execution.status}
            </span>
            <span>
              <b>Created at:</b> {dayjs(execution.started_at).format("DD/MM/YYYY HH:mm:ss")}
            </span>
            <span>
              <b>Ended at:</b> {dayjs(execution.ended_at).format("DD/MM/YYYY HH:mm:ss")}
            </span>
            <span>
              <b>Duration:</b>{" "}
              <span
                style={
                  execution.duration > 1000
                    ? {
                        color: "#e74c3c",
                      }
                    : {}
                }
              >
                {execution.duration >= 0 ? execution.duration + "ms" : "-"}
              </span>
            </span>
            <span>
              <b>Operations:</b> {execution.operations_consumed}
            </span>
          </button>
        </ExecutionNodesSheet>
      ))}
    </div>
  )
}
